import { CustomShopOrder } from './../models/custom-shop-order.model';
import { APP } from '@/constants/app.constant';
import { CustomResponse } from '@/models/custom-response.model';
import axios from 'axios';
import fileDownload from 'js-file-download';

export const OrderService = {
    create,
    setPayment,
    exportData,
};

function create(order: CustomShopOrder): Promise<CustomResponse<CustomShopOrder>> {
    return axios.post(`${APP.API_URL}/shop/orders`, order)
        .then(handleResponse)
        .then((response: CustomResponse<CustomShopOrder>) => {
            response.data = new CustomShopOrder(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function setPayment(orderId: number, paymentId: string): Promise<CustomResponse<CustomShopOrder>> {
    return axios.patch(`${APP.API_URL}/shop/orders/${orderId}/payment`, { payment_id: paymentId })
        .then(handleResponse)
        .then((response: CustomResponse<CustomShopOrder>) => {
            response.data = new CustomShopOrder(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function exportData(params?: any): Promise<any> {
    return axios.get(
        `${APP.API_URL}/shop/orders/export`,
        {
            params,
            headers: {
                Accept: 'application/vnd.ms-excel',
            },
            responseType: 'blob',
        },
    ).then((response) => {
            const disposition = response.headers['content-disposition'];
            const filename = decodeURI(disposition.match(/filename="(.*)"/)[1]);
            fileDownload(response.data, filename);
            return response;
        })
        .catch((error) => {
            throw error.response && error.response.data;
    });
}


function handleResponse(response: any): CustomResponse<any> {
    return response.data;
}
